import { Component } from '@grafikr/components';
import classNames from 'classnames';

import clear from 'utils/clear';

export default Component((node, { onMounted }) => {
  const { sku } = node.dataset;

  const handleize = (text: string) => text.replace(/[^\w#]+/g, '').toLowerCase();

  const renderSwatches = (items) => {
    if (!items) {
      node.hidden = true;
      return;
    }

    clear(node);

    items.forEach((item) => {
      const sanitized = handleize(item.color);
      const isWhite = sanitized.includes('white') || sanitized.includes('#ffffff');

      node.insertAdjacentHTML(
        'beforeend',
        String.raw`
          <a href=${item.url} class="${classNames(
            'h-2 w-6 bg-[--bg-color] border border-[--bg-color]',
            {
              '!border-black/30': isWhite,
            },
          )}" style="--bg-color: ${sanitized}"></a>
        `,
      );
    });
  };

  const init = async () => {
    if (!sku) {
      node.hidden = true;
      return;
    }

    const related = await window.linkedProducts.getRelated(sku);

    renderSwatches(related);
  };

  onMounted(() => {
    init();
  });
});
